import React from "react";
import "./Komersial1.scss";
import data from "./data.json";
import Card from "../../../Component/CardRuko/cardruko";
import Latinosimages from "../../../Media/Ruko BSD/Latinos/latinos";
import Theloopimages from "../../../Media/Ruko BSD/The Loop/Theloop";
import westvillageimages from "../../../Media/Ruko BSD/West Village/westvillage";
import Vanyaparkimages from "../../../Media/Ruko BSD/Vanya/Vanya";
import Xlaneimages from "../../../Media/Ruko BSD/Xline/Xlane";
import Northridgeimages from "../../../Media/Ruko BSD/Northridge/Northridge";
import Cascadeimages from "../../../Media/Ruko BSD/Cascade/Cascade";
import Tamanteknoimages from "../../../Media/Ruko BSD/Taman Tekno/Tamantekno";
import Delreyimages from "../../../Media/Ruko BSD/Delrey/delrey";
import Iconiximages from "../../../Media/Ruko BSD/Iconix/Iconix";
import Northpointimages from "../../../Media/Ruko BSD/NTP/Northpoint";
import Capitalcoveimages from "../../../Media/Ruko BSD/Capital Cove/Capitalcove";
import NavaparkBusinessimages from "../../../Media/Ruko BSD/Navapark Business Suites/NavaparkBusiness";
import IconixIimages from "../../../Media/Ruko BSD/Iconix Infinite/IconixI";

const imageMap = {
  Latinosimages,
  Theloopimages,
  westvillageimages,
  Vanyaparkimages,
  Xlaneimages,
  Northridgeimages,
  Cascadeimages,
  Tamanteknoimages,
  Delreyimages,
  Iconiximages,
  Northpointimages,
  Capitalcoveimages,
  NavaparkBusinessimages,
  IconixIimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Our Options to Fulfill your Business</h1>
      <h2>Cicilan Start 9 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
